import { SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

const CAMPAIGN_GROUP_SORTABLE_FIELDS = {
    TOTAL_SPENT: 'totalSpent',
    STATUS: 'status',
    ID: 'id',
};
const defaultSortField = 'status';
const defaultSortType = SORTING_ORDER_TYPES.ASCENDANT;

export const campaignGroupSortFieldsOptions = [
    {
        value: CAMPAIGN_GROUP_SORTABLE_FIELDS.STATUS,
        label: <FormattedMessage id="campaign.group.picker.sorting.status" defaultMessage="Status" />,
    },
    {
        value: CAMPAIGN_GROUP_SORTABLE_FIELDS.TOTAL_SPENT,
        label: <FormattedMessage id="campaign.group.picker.sorting.totalSpent" defaultMessage="Total Spend" />,
    },
];

export default CAMPAIGN_GROUP_SORTABLE_FIELDS;
export { defaultSortField, defaultSortType };
